/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.BusinessInfo {
    'use strict';

    import WeekdayNameEnum = Meevo.Model.WeekdayNameEnum;

    export interface IBusinessInfoItemSettings {
        displayName: string;
        effectiveValue: string;
        id: number;
        settableLevels: number;
        securityKey?: string;
    }

    export interface IHelpSectionSettings {
        bookRemoteTrainingUrl: string;
        meevoInspoUrl: string;
        referAFriendUrl: string;
        meevoFacebookGroupUrl: string;
        groupEnum: number;
    }

    export interface IBusinessInfoMetadata {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface IBusinessInfoSetting {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: IBusinessInfoMetadata;
        securityKey: string;
    }

    export interface IBusinessInfoAppointmentBookSettings {
        allowAnonymousClient: boolean;
        allowOnlineBooking: boolean;
        applyNoShowFeeToAddOns: boolean;
        appointmentBookChunkSize: number;
        appointmentBookIncrement: number;
        appointmentBookPageSize: number;
        appointmentNoShowFeePercentage: number;
        archivalWaitPeriodInDays: number;
        cancelNoShowIndicator: boolean;
        cancelNoShowIndicatorNumberOfWeeksBack: number;
        cancelNoShowNumberOfDaysBack: number;
        defaultAppointmentBookColumnZoom: number;
        defaultAppointmentBookView: number;
        defaultAppointmentBookTimeZoom: number;
        displaysEmployeeNameInListOfOpenings: boolean;
        employeesAvailableToBook: number;
        employeeScheduleAppointBook: number;
        enableConvobarAppointmentSuggestions: boolean;
        enableEmployeeSearch: boolean;
        enableIntelliBooking: boolean;
        enhancedBookingMode: boolean;
        eventEntityVersion: number;
        hideAnyMaleAnyFemaleInCallCenter: boolean;
        holidayEntityVersion: number;
        isProductivityNeutralBlockEnabled: boolean;
        markAppointmentAsNoShow: boolean;
        markAppointmentAsNoShowAfterMinutes: number;
        maxDaysToAllowServiceStartTimeEdit: number;
        maxDaysToAllowServiceStepEdit: number;
        maxNumberOfAppointmentServicesInAnAppointment: number;
        maxNumberOfAppointmentServicesPerEmployeePerDay: number;
        maxNumberOfDoubleBookingPerTimeSlot: number;
        moveServicesAsGroup: boolean;
        multiClientAptMessage: string;
        newClientIndicatorEnum: number;
        perpetualServiceScheduleInterval: number;
        perpetualServiceScheduleTotalOccurrences: number;
        precisionMode: boolean;
        preventAppointmentsFromBeingBookedForXHours: number;
        promptDragDropAppointmentOnMobile: boolean;
        promptForCardOnFileWhenBookingAppointments: boolean;
        requestedAppointmentDefaultFlag: number;
        requireAppointmentCategory: boolean;
        requireCancellationReasonWhenDeletingAnAppointment: boolean;
        resourcePriorityAutoReorderIntervalInMonths: number;
        resultsPerSlotCount: number;
        resultsPerTimeSlot: boolean;
        showAddressOnAppointmentBook: boolean;
        showAddressOnSmartAssistant: boolean;
        showAppointmentCategory: boolean;
        showEmployeesAvailableCount: boolean;
        showIsAddressRequired: boolean;
        showResourcesAvailableCount: boolean;
        showUnScheduledEmployeeOnAppointmentBook: boolean;
        startAppointmentBookDayOn: WeekdayNameEnum;
        useGenderPreferenceWhenBookingAppointments: boolean;
        waitlistAppointmentBufferHours: number;
        waitListDisplayPhoneNumber: boolean;
        waitListNumberOfDaysToScan: number;
        waitListNumberOfMonthsInAdvance: number;
        waitListPendingSmsTimeoutInMinutes: number;
        waitListRejectedOpeningTimeBlackoutMinutes: number;
        workTicketPrintOneTicketPerEmployee: boolean;
        workTicketPromptCheckInOnPrint: boolean;
        workTicketShowPricing: boolean;
        workTicketShowServicePricesOnTodaysServices: boolean;
        workTicketShowTransactionHistory: boolean;
        workTicketShowVisitNotes: boolean;
        workTicketShowVisitNotesFromAllLocations: boolean;
        appointmentBookPrecisionIncrement: number;
        settings: IBusinessInfoSetting[];
        groupEnum: number;
    }

    export interface IBusinessInfoMetadata2 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting2 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: IBusinessInfoMetadata2;
    }

    export interface IBusinessInfoClientsSettings {
        allowNotificationSettingsBulkUpdate: boolean;
        allowSharedRedemptionFamilyPoints: boolean;
        allowViewingDocsAndFormsAcrossLocations: boolean;
        basicMarketingClientExportLimit: number;
        clientVisitCalculatedBasedOnEnum: number;
        defaultClientSortOrder: number;
        enablePurge: boolean;
        forceGenderSelection: boolean;
        genderSpecificAnonClient: boolean;
        localClientSearchOnly: boolean;
        nonRequestClientIsItalic: boolean;
        requireNewClientEmail: boolean;
        requireNewClientPhoneNumber: boolean;
        hideClientPhoneConfirmation: boolean;
        requireNewClientReferralType: boolean;
        requireNewClientReferralTypeSource: boolean;
        showTransactionHistoryForMultipleLocation: boolean;
        showVisitNoteForMultipleLocation: boolean;
        specifyParentGuardianWhenMinorSelected: boolean;
        enableOptOutOfClientInfoSellOrShare: boolean;
        settings: Setting2[];
        groupEnum: number;
        requireRestrictedClientToBeUnlocked: boolean;
        doNotAllowEditingOfRestrictedClients: boolean;
    }

    export interface Metadata3 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting3 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata3;
        securityKey: string;
    }

    export interface IBusinessInfoMembershipSettings {
        allowOffsiteMembershipAccruedServiceTransfers: boolean;
        autoGenerateMembershipNumber: boolean;
        billingEngineLocationRunTime: Date;
        billingEngineNumberOfDaysToRunInPast: number;
        clientCCFileMissingZipCode: boolean;
        daysToRefundMembership: number;
        defaultAccruedServiceExpirationTerm: number;
        defaultCancellationTerm: number;
        eftToBeProcessedStatusEnum: number;
        enableAutoBillingService: boolean;
        enableMembershipBilling: boolean;
        requireEmailForMembershipSale: boolean;
        settings: Setting3[];
        groupEnum: number;
    }

    export interface Metadata4 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
        tenantValue: string;
    }

    export interface Setting4 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata4;
    }

    export interface IBusinessInfoRegisterSettings {
        allowExpiredPackagesForRedemptionAtAnyLocation: boolean;
        allowProductRefundingResell: boolean;
        archiveSalesOnHoldSystemMaintenanceDateWarningWindow: number;
        autoGenerateGiftCardNumberButton: boolean;
        defaultPriceLevelsForService: number;
        defaultTipCalculations: number;
        defaultTipType: number;
        disablePrintingOfMerchantCreditCardReceipt: boolean;
        enableCreditCardProcessing: boolean;
        enableSignatureCaptureOnCreditCardDevice: boolean;
        enableTipRefunds: boolean;
        giftCardWildcardSearchMinChars: number;
        maxNumberOfTipValues: number;
        numberOfDaysProductCanBeRefunded: number;
        numberOfDaysTipCanBeRefunded: number;
        numberOfWeeksStandrardGiftCardExpiresAfterPurchase: number;
        printEarnedPointsOnReceipt: boolean;
        printGiftCardBalanceOnReceipts: boolean;
        includeOffsiteAppointmentsOnSaleReceipt: boolean;
        printPointsAndValueOnReceipt: boolean;
        doNotDisplaySpecialPriceOnReceipt: boolean;
        doNotPrintPointsValueOnReceipt: boolean;
        printStoreNumberOnReceipts: boolean;
        printTotalDiscounts: boolean;
        reloadGiftCard: boolean;
        restrictGiftCardViewingRedemption: boolean;
        restrictOffsiteGiftCardRefund: boolean;
        reuseGiftCard: boolean;
        selfPayLinkExpirationHours: number;
        selfPayReminderSendHoursAfter: number;
        showAnonymousClient: boolean;
        showProductRecommendations: boolean;
        showRebookPrompt: number;
        suppressValuePackageItemsRemainingReceipt: boolean;
        validateSaleTotal: boolean;
        visitNoteServicePrompt: boolean;
        enableIntegratedRegister: boolean;
        settings: Setting4[];
        groupEnum: number;
        defaultGiftCardType: string;
        clientAccountSpendingLimit: number;
        enableClientAccountSpendingLimit: boolean;
    }

    export interface Metadata5 {
        settingId: number;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
        systemValue: string;
    }

    export interface Setting5 {
        id: number;
        displayName: string;
        settableLevels: number;
        metadata: Metadata5;
        effectiveValue: string;
    }

    export interface IBusinessInfoUsersSettings {
        defaultLearningTrack: number;
        lockAccountAfterFailedLoginsPolicy: number;
        maxNumberOfEmployees: number;
        passwordExpirationDaysPolicy: number;
        passwordExpirationGracePeriod: number;
        repeatLastPasswordDaysPolicy: number;
        sessionTimeoutMinutes: number;
        syncUsersToSalesForce: boolean;
        settings: Setting5[];
        groupEnum: number;
    }

    export interface Metadata6 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting6 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata6;
    }

    export interface IBusinessInfoClientPointSettings {
        allowPointsRewardWhenPointsRedeemed: boolean;
        allowViewingRedemption: boolean;
        dollarsValue: number;
        expireClientPoints: number;
        pointsValue: number;
        settings: Setting6[];
        groupEnum: number;
    }

    export interface Metadata7 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting7 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata7;
    }

    export interface IBusinessInfoLicenseInsuranceSettings {
        daysToExpirationWarning: number;
        showDaysToExpirationWarning: boolean;
        settings: Setting7[];
        groupEnum: number;
    }

    export interface Metadata8 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting8 {
        id: number;
        displayName: string;
        effectiveValue: string;
        securityKey: string;
        settableLevels: number;
        metadata: Metadata8;
    }

    export interface IBusinessInfoHelpDeskTicketSettings {
        liveChatSupport: boolean;
        liveChatSupportUrl: string;
        salesforceSupport: boolean;
        salesforceSupportUrl: string;
        settings: Setting8[];
        groupEnum: number;
    }

    export interface Metadata9 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting9 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata9;
    }

    export interface IBusinessInfoCulturalSettings {
        countryEnum: number;
        currencyCodeEnum: number;
        locale: string;
        timeFormatEnum: number;
        settings: Setting9[];
        groupEnum: number;
    }

    export interface Metadata10 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting10 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata10;
    }

    export interface IBusinessInfoFieldLabelsSettings {
        appointment: string;
        appointmentCategory: string;
        areaInstallManager: string;
        areaSalesManager: string;
        client: string;
        employee: string;
        package: string;
        product: string;
        resource: string;
        service: string;
        student: string;
        teacher: string;
        tip: string;
        settings: Setting10[];
        groupEnum: number;
    }

    export interface Metadata11 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting11 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata11;
    }

    export interface IBusinessInfoSmartCenterSettings {
        autoLoadSmartCenter: boolean;
        settings: Setting11[];
        groupEnum: number;
    }

    export interface Metadata12 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting12 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata12;
    }

    export interface IBusinessInfoReportSchedulerSettings {
        reportScheduleLimit: number;
        reportURLExpiryLimit: number;
        reportURLExpiryLimitDaily: number;
        reportURLExpiryLimitMonthly: number;
        reportURLExpiryLimitWeekly: number;
        settings: Setting12[];
        groupEnum: number;
    }

    export interface Metadata13 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
        tenantValue: string;
    }

    export interface Setting13 {
        id: number;
        displayName: string;
        effectiveValue: string;
        settableLevels: number;
        metadata: Metadata13;
        securityKey: string;
    }

    export interface IBusinessInfoNotificationBISettings {
        enableAppointmentNotification: boolean;
        enableEmailScheduledNotificationTime: boolean;
        enableEmailService: boolean;
        enableMeevoDefaultEmailDomain: boolean;
        enableSmsScheduledNotificationTime: boolean;
        enableSmsService: boolean;
        invalidMessageRepliesLimit: number;
        settings: Setting13[];
        groupEnum: number;
        showTransactionHistoryForMultipleLocation: boolean;
        showVisitNoteForMultipleLocation: boolean;
        allowSharedRedemptionFamilyPoints: boolean;
        allowViewingDocsAndFormsAcrossLocations: boolean;
        showClientNotesAcrossLocation: boolean;
        displayPopupNotesAcrossLocations: boolean;
        doNotAllowEditingOfRestrictedClients: boolean;
        requireRestrictedClientToBeUnlocked: boolean;
        requireSameLocationToUnrestrict: boolean;
        requirePrivacyPolicyAndTermsAndConditions: boolean;
    }

    export interface Metadata14 {
        settingId: number;
        systemValue: string;
        calculationRule: number;
        effectiveLevel: number;
        isEnable: boolean;
    }

    export interface Setting14 {
        id: number;
        displayName: string;
        effectiveValue: string;
        securityKey: string;
        settableLevels: number;
        metadata: Metadata14;
    }

    export interface IBusinessInfoHelpSectionSettings {
        bookRemoteTrainingUrl: string;
        millenniumInspoUrl: string;
        referAFriendUrl: string;
        meevoFacebookGroupUrl: string;
        settings: Setting14[];
        groupEnum: number;
        releaseNotesUrl: string;
        dashboardsHelpUrl: string;
        knowledgeArticlesUrl: string;

    }

    export interface IPaymentPlansSettings {
        displayPassiveAlerts: boolean;
        enablePaymentPlans: boolean;
        maximumNumberOfPayments: number;
        maximumPaymentPlanAmount: number;
        settings: {
            id: number;
            displayName: string;
            effectiveValue: string;
            settableLevels: number;
        }[];
        groupEnum: number;
    }

    export interface IBusinessInfoSettings {
        locationId: number;
        storeName: string;
        imageUrl?: string;
        appointmentBookSettings: IBusinessInfoAppointmentBookSettings;
        clientsSettings: IBusinessInfoClientsSettings;
        membershipSettings: IBusinessInfoMembershipSettings;
        registerSettings: IBusinessInfoRegisterSettings;
        usersSettings: IBusinessInfoUsersSettings;
        clientPointSettings: IBusinessInfoClientPointSettings;
        licenseInsuranceSettings: IBusinessInfoLicenseInsuranceSettings;
        helpDeskTicketSettings: IBusinessInfoHelpDeskTicketSettings;
        culturalSettings: IBusinessInfoCulturalSettings;
        fieldLabelsSettings: IBusinessInfoFieldLabelsSettings;
        smartCenterSettings: IBusinessInfoSmartCenterSettings;
        reportSchedulerSettings: IBusinessInfoReportSchedulerSettings;
        notificationBISettings: IBusinessInfoNotificationBISettings;
        helpSectionSettings: IBusinessInfoHelpSectionSettings;
        paymentPlansSettings: IPaymentPlansSettings;
    }
}
